import React, { useState } from "react";
import { Card, CardHeader, Col, Collapse, Container, Label, Row, Table } from "reactstrap";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";
import { Deducibles } from "../../../coms/siniestros/Deducibles";

export const DeducibleAccordion = ({ deducibles }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Deducibles"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <div>
                                <small className="align-items-center text-primary">
                                    <i className="fas fa-circle mr-2 m-lg-0" />
                                    <Label className="m-2">Aplicado </Label>
                                </small>
                                <small className="align-items-center text-primary">
                                    <i className="fas fa-circle mr-2 text-yellow m-lg-0" />
                                    <Label className="m-2">Por Aplicar </Label>
                                </small>
                            </div>
                            <Deducibles deducible={deducibles} space={true} />
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};

export const DeduciblesVehi = ({ otros, coberturas }) => {
    return (
        <Container className="text-center">
            <Row>
                <h4>{"Deducibles por Cobertura"}</h4>
                <Col className={"table-responsive col-lg-12"}>
                    <React.Fragment>
                        <Table className="adjusttd text-center">
                            <thead className="text-primary">
                                <tr>
                                    <th>Item</th>
                                    <th>Cobertura</th>
                                    <th>%Val Sinies</th>
                                    <th>%Val Asegur</th>
                                    <th>Val Mínimo</th>
                                    <th>Val Fijo</th>
                                    <th>Observaciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {coberturas.length === 0 ? (
                                    <React.Fragment>
                                        <tr>
                                            <td colSpan={4}>
                                                <span>No hay información disponible.</span>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {coberturas.map((item, index) => (
                                            <tr key={item.cdDeducible}>
                                                <td>
                                                    <span>{index + 1}</span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 220 }}>
                                                    <span>{item.nmCobertura}</span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 120 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.pctReclamo ? item.pctReclamo : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 120 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.pctVAseg ? item.pctVAseg : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.valMinimo ? item.valMinimo : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.valFijo ? item.valFijo : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>{item.obsDeducible}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                )}
                            </tbody>
                        </Table>
                    </React.Fragment>
                </Col>
            </Row>

            <Row>
                <h4>{"Otros Deducibles"}</h4>
                <Col className={"table-responsive col-lg-12"}>
                    <React.Fragment>
                        <Table className="adjusttd text-center">
                            <thead className="text-primary">
                                <tr>
                                    <th>Item</th>
                                    <th>%Val Sinies</th>
                                    <th>%Val Asegur</th>
                                    <th>Val Mínimo</th>
                                    <th>Val Fijo</th>
                                    <th>Observaciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {otros.length === 0 ? (
                                    <React.Fragment>
                                        <tr>
                                            <td colSpan={4}>
                                                <span>No hay información disponible.</span>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {otros.map((item, index) => (
                                            <tr key={item.cdDeducible}>
                                                <td>
                                                    <span>{index + 1}</span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 120 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.pctReclamo ? item.pctReclamo : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 120 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.pctVAseg ? item.pctVAseg : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.valMinimo ? item.valMinimo : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>
                                                        <ReactNumeric
                                                            valuex={item.valFijo ? item.valFijo : 0}
                                                            readOnly
                                                            className="form-control-plaintext text-right"
                                                        />
                                                    </span>
                                                </td>
                                                <td className="text-left" style={{ maxWidth: 180 }}>
                                                    <span>{item.obsDeducible}</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                )}
                            </tbody>
                        </Table>
                    </React.Fragment>
                </Col>
            </Row>
        </Container>
    );
};
